// extracted by mini-css-extract-plugin
module.exports = {"arrow-btn-box":"U","arrowBtnBox":"U","arrow-btn-wrap-box":"V","arrowBtnWrapBox":"V","arrow-btn-text":"W","arrowBtnText":"W","arrow-btn-arrow":"X","arrowBtnArrow":"X"};